import React from 'react'
import { C } from '../../../Shared/Brand'
import { PageHeader, TableWrap } from '../../../Shared/DashboardUI'

function History() {
  return (
    <>
      <PageHeader title="Order History" />
      <div className="xdb-card" style={{ marginBottom: '16px' }}>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <input type="text" className="xdb-input" style={{ maxWidth: '220px' }} placeholder="Enter TxID" />
          <select className="xdb-input" style={{ maxWidth: '150px' }} defaultValue="1">
            <option value="1">Deposit</option>
            <option value="2">Withdraw</option>
            <option value="3">Transfer</option>
          </select>
          <select className="xdb-input" style={{ maxWidth: '150px' }} defaultValue="2">
            <option value="1">1 Days</option>
            <option value="2">7 Days</option>
            <option value="3">15 Days</option>
            <option value="4">30 Days</option>
            <option value="5">Custom</option>
          </select>
          <select className="xdb-input" style={{ maxWidth: '150px' }} defaultValue="all">
            <option value="all">All Coins</option>
            <option value="1">Buy</option>
            <option value="2">Sell</option>
          </select>
          <select className="xdb-input" style={{ maxWidth: '150px' }} defaultValue="all">
            <option value="all">All Status</option>
            <option value="1">Buy</option>
            <option value="2">Sell</option>
          </select>
        </div>
      </div>
      <TableWrap>
        <thead>
          <tr>
            <th>Date</th><th>Wallet Type</th><th>Coin</th><th>Amount</th>
            <th>Destination</th><th>TxID</th><th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>06-14-24 10:35:42</td>
            <td>Spot</td>
            <td>USDT</td>
            <td style={{ color: C.primary }}>315.50 USDT</td>
            <td>Withdraw</td>
            <td>txn-9871dfcd-45</td>
            <td>315.50 USDT</td>
          </tr>
        </tbody>
      </TableWrap>
    </>
  )
}

export default History
